import "./style.css";
import Form from "@/components/Form";

export default class ContactForm {
    static selector = '.contact-form';

    constructor(block) {
        this.block = block;

        this.formElement = this.block.querySelector(".form");

        this.form = new Form(this.formElement, {
            submitLoadingLabel: 'Sending...',
            submitSuccessLabel: 'Sent',
            onSubmitSucceeded: this.handleSubmitSucceeded,
            resetAfterSubmit: false,
            gainControlOnSubmitSucceeded: false,
        })
    }

    handleSubmitSucceeded = (response) => {
        console.log('Success!', response);
    };
}
